import React, { useState, useRef, useEffect } from 'react';
import 'primereact/resources/themes/lara-light-blue/theme.css'
import '../../styles/global.css';
import '../../styles/pages/CadastroFarm.css';
import '@geoman-io/leaflet-geoman-free'
import * as mapas from '../../utils/mapas';
import { Messages } from 'primereact/messages';
import { Button } from 'primereact/button';
import { ConfirmDialog } from 'primereact/confirmdialog';
import { Dialog } from 'primereact/dialog';
import { Toast } from 'primereact/toast';
import { Calendar } from 'primereact/calendar';
import GrassIcon from '@mui/icons-material/Grass';
import EventIcon from '@mui/icons-material/Event';
import PollIcon from '@mui/icons-material/Poll';
import AddCircleIcon from '@mui/icons-material/AddCircle';
import { InputNumber } from 'primereact/inputnumber';
import Cookies from 'js-cookie';
import API from '../../api/API'
import { DataTable } from 'primereact/datatable';
import { PlantioType, LoteType, newPlantio, mapStringToAny, newPlano, PessoaType, ImovelType, PlanoType } from '../../db/Orm';
import { PiPlantFill } from "react-icons/pi";
import { MdMap } from "react-icons/md";
import { Badge } from 'primereact/badge';
import { ProgressSpinner } from 'primereact/progressspinner';
import { Column } from 'primereact/column';
import { Divider } from 'primereact/divider';
import { LotesSelect } from '../components/LotesSelect';
import { ToggleButton } from 'primereact/togglebutton';
import { FaArrowUpFromWaterPump } from 'react-icons/fa6';
import { GiWaterDrop } from 'react-icons/gi';
import { FaTimes, FaWater } from 'react-icons/fa';
import { AutoComplete, AutoCompleteCompleteEvent } from 'primereact/autocomplete';
import Embrapa from '../../api/Embrapa';
import BadgeIcon from '@mui/icons-material/Badge';
import { InputMask, InputMaskChangeEvent, InputMaskCompleteEvent } from 'primereact/inputmask';
import { PiIdentificationBadgeFill } from 'react-icons/pi';
import InsertDriveFileIcon from '@mui/icons-material/InsertDriveFile';
import axios from 'axios';
import DocumentFileUpload from '../components/DocumentFileUpload';
import Auth from '../../auth/Authenticator';
import InputCpfCnpj from '../components/InputCpfCnpj';

export enum CadastroPlantioConfig {
    CADASTRO_PRODUTOR,
    APROVACAO_RT,
    APROVACAO_AIBA,
    APROVACAO_ADAB,
    APENAS_VISUALIZACAO,
}

type CadastroPlantioProps = {
    visible: boolean
    propriedades: Array<ImovelType>
    propriedade?: ImovelType
    setVisible: Function
    config: CadastroPlantioConfig
    plano: PlanoType | null
    plantios?: PlantioType[]
}

// type PlantioCadastroType = PlantioType & {
//     lotes: Array<LoteType>
// }

export default function CadastroPlantio(props: CadastroPlantioProps) {
    const auth = Auth.useAuth();
    const [plantio, setPlantio] = useState<PlantioType>(newPlantio());
    const [plantios, setPlantios] = useState<Array<PlantioType>>(props.plantios || []);
    const msgs = useRef<any>(null);
    const [culturas, setCulturas] = useState<Array<any>>([])
    const [listaCulturas, setListaCulturas] = useState<Array<string>>([])
    const [variedades, setVariedades] = useState<Array<any>>([])
    const [listaVariededes, setListaVariedades] = useState<Array<string>>([])
    const mapCulturasToCode = useRef<mapStringToAny>({})
    const mapCultivarToVariedade = useRef<mapStringToAny>({})
    const [lotes, setLotes] = useState<Array<any>>([])
    const [waiting, setWaiting] = useState<boolean>(false)
    const [countLotes, setCountLotes] = useState<number>(0)
    const [lockPropriedade, setLockPropriedade] = useState<boolean>(false)
    const [pessoaRT, setPessoaRT] = useState<PessoaType | null>(null)
    const [drt, setDrt] = useState<number | null>(null)
    const [files, setFiles] = useState<Array<any>>([])
    const [fileSize, setFileSize] = useState<string>('')
    const [cpfNome, setCpfNome] = useState<string>('')
    const [campoCpfCnpj, setCampoCpfCnpj] = useState<string>('')
    const [tipoRT, setTipoRT] = useState<'cpf' | 'cnpj'>('cpf');

    // console.log('Propriedades no CadastroPlantio', props.propriedades)  

    const carregarCulturas = async () => {
        //console.log('carregarCulturas')
        const apikey = Embrapa.keys.agritec
        const url = Embrapa.urls.agritec_culturas
        let json: any = {}
        let data: Array<any> = []
        try {
            json = await Embrapa.fetchOrLoad(url, apikey)
            data = await json.data as Array<any>
        } catch (error) {
            console.error('Erro ao carregar culturas da Embrapa:', error)
        }
        setCulturas(data)
        data.forEach((val) => {
            mapCulturasToCode.current[val.nome] = val.id
        })
        //console.log('culturas', data)
        //console.log('mapCulturasToCode', mapCulturasToCode.current)
    }
    const carregarVariedades = async (id: number) => {
        const apikey = Embrapa.keys.agritec
        const url = `${Embrapa.urls.agritec_cultivares}?safra=2024-2025&idCultura=${id}&uf=BA&dataAtualizacao=2024-01-01`
        //console.log('URL', url)
        const json = await Embrapa.fetchOrLoad(url, apikey)
        const data: Array<any> = json.data
        setVariedades(data)
        //console.log('Variedades', data)
        mapCultivarToVariedade.current = {}
        data.forEach((variedade) => { mapCultivarToVariedade.current[variedade.cultivar] = variedade })
        //console.log('mapCultivarToVariedade', mapCultivarToVariedade.current)
    }
    function changeFieldGeneric(event: any) {
        const { value, name } = event.target;
        //console.log('ChangeField', name, value)
        setPlantio({ ...plantio, [name]: value })
    }
    function changeFieldCultura(event: any) {
        changeFieldGeneric(event)
        const code = mapCulturasToCode.current[event.target.value]
        typeof code === 'number' && carregarVariedades(code)
    }
    function changeFieldVariedade(event: any) {
        //console.log(event, mapCultivarToVariedade.current)
        const variedadeObject = mapCultivarToVariedade.current[event.target.value]
        if (!variedadeObject) {
            changeFieldGeneric(event)
            return
        }
        //console.log(variedadeObject)
        plantio.produtividade = variedadeObject.potencialProdutivo
        setPlantio({ ...plantio, produtividade: variedadeObject.potencialProdutivo, variedade: event.target.value })
    }
    function changeFieldDRT(event: any) {
        setDrt(event.value)
    }
    function onCpfCnpjSetValue(value: string) {
        setCampoCpfCnpj(value)
        const digits = value.replace(/\D/g, '');
        if ((tipoRT === 'cpf' && digits.length !== 11) || (tipoRT === 'cnpj' && digits.length !== 14)) {
            setCpfNome('')
            setPessoaRT(null);
        }
    }
    async function completeFieldCPF(event: InputMaskCompleteEvent) {
        setCpfNome('Carregando')
        const req = await axios.get(API.url + 'pessoas/?cpf_cnpj=' + event.value + '&status=A', { headers: { Authorization: 'Bearer ' + Cookies.get('token') } })
        console.log(req)
        if (req.data[0]) {
            setPessoaRT(req.data[0])
            //console.log('Pessoa:', req.data[0])
            setCpfNome(req.data[0].nome_razao)
        } else {
            setCpfNome('Este CPF/CNPJ não está cadastrado')
        }
    }
    const addPlantio = () => {
        //console.log('Plantio', plantio)
        if (lotes.length === 0) return
        const cadPlantio: PlantioType = { ...plantio, lotes: [...lotes] }
        cadPlantio.lotes?.sort((a, b) => (a.id || 1) - (b.id || 2))
        setPlantios([...plantios, cadPlantio])
        setPlantio(newPlantio())
        setVariedades([])
        setListaVariedades([])
    }
    const plantioTemplate = (plantio: PlantioType) => {
        return plantio.data?.toLocaleDateString('pt-BR')
    }
    const produtividadeTemplate = (plantio: PlantioType) => {
        return plantio.produtividade?.toLocaleString('pt-BR')
    }
    const irrigacaoTemplate = (plantio: PlantioType) => {
        return <>
            <div style={{ display: 'flex', gap: '1em' }}>
                {plantio.irrigacao_fluvial && <FaWater size={'2em'}></FaWater>}
                {plantio.irrigacao_poco && <FaArrowUpFromWaterPump size={'2em'}></FaArrowUpFromWaterPump>}
                {!(plantio.irrigacao_fluvial || plantio.irrigacao_poco) && <FaTimes size={'2em'}></FaTimes>}
            </div>
        </>
    }
    const deletePlantio = (plantio: PlantioType) => {
        setPlantios(plantios.filter(p => p !== plantio))
    }
    const actionBodyTemplate = (plantio: PlantioType) => {
        return <Button severity="danger" icon="pi pi-times" rounded onClick={() => deletePlantio(plantio)} />;
    };
    const lotesTemplate = (plantio: PlantioType) => {
        return plantio.lotes?.reduce((acum, lote, index, lotes) => {
            return acum + lote.id + (index < lotes.length - 1 ? ', ' : '')
        }, '')
    }

    const [propriedade, setPropriedade] = useState<ImovelType | null>(props.propriedade ? props.propriedade : null)
    const [loading, setLoading] = useState<boolean>(false)
    const mapRef = useRef<any>()
    const [map, setMap] = useState<any>(null)
    //REMOVIDO DAQUI
    // const loadPropriedades = async () => {
    //     console.log('Global User:', global.user)
    //     //TODO mandar o navigate ao inves de null ou receber propriedades do global
    //     const propriedades = await api.getPropriedades(null, () => console.log('erro'), undefined, global.user.groups[0].name === 'Fiscal ADAB' ? undefined : global.user,)
    //     setPropriedades(propriedades.map((p: PropriedadeType) => {
    //         return { name: p.nome, code: p.id, object: p }
    //     }))
    //     setLoading(false)
    // }

    // const [lotes2, setLotes2] = useState<Array<any>>([])
    // const selectLote = (index: number, lote: LoteType, polygon: any) => {
    //     if (lotes2.length > 0) {
    //         if (lotes2[index].color === mapas.estiloSelected.fillColor) {
    //             lotes.splice(lotes.indexOf(lote), 1)
    //             polygon.setStyle(mapas.estiloArea)
    //             lotes2[index].color = mapas.estiloArea.fillColor
    //         }
    //         else {
    //             polygon.setStyle(mapas.estiloSelected)
    //             lotes2[index].color = mapas.estiloSelected.fillColor
    //             lotes.push(lote)
    //         }
    //     }
    //     setCountLotes(lotes.length)
    // }
    // const carregarPropriedade = async () => {
    //     if (propriedade) {
    //         mapas.clearMap(map)
    //         setCountLotes(0)
    //         lotes.splice(0, lotes.length)
    //         const polig = await mapas.carregarZipFromURL(propriedade.object.poligono, mapas.estiloContorno)
    //         if (map && polig) {
    //             polig.addTo(map)
    //             map?.flyToBounds(polig.getBounds())
    //             const data = (await api.getData(api.api + 'lotes/?propriedade=' + propriedade.object.id, navigate, () => console.log('Error')))
    //             lotes2.splice(0, lotes2.length);
    //             data.map(async (lote: any, index: number) => {
    //                 const p = await mapas.carregarZipFromURL(lote.poligono, mapas.estiloArea)
    //                 p.addTo(map)
    //                 p.on('click', async () => { selectLote(index, lote, await p) })
    //                 lotes2.push({ index: index, lote: lote, poligono: await p, color: mapas.estiloArea.fillColor })
    //             });
    //         }
    //     }
    // }
    // useEffect(() => {
    //     carregarPropriedade()
    //     map?.invalidateSize();
    // }, [propriedade])

    // useEffect(() => {
    //     loadPropriedades()
    //     //carregarCulturas()
    //     console.log('Lotes count', lotes.length)
    //     console.log('Lotes', lotes)
    // }, [])
    /** ATÉ AQUI **/
    useEffect(() => {
        try {
            if (props.visible && mapRef.current) {
                if (mapRef.current && !map) {
                    const map = mapas.createMapOnBahia(mapRef)
                    mapas.refreshingMap(map, setLoading)
                    setMap(map)
                }
                setTimeout(() => {
                }, 100); // Pequeno atraso para garantir que o Dialog esteja completamente renderizado
            }
        } catch (e: any) { console.log('Error:', e) }
    }, [props.visible, mapRef.current]);

    useEffect(() => {
        console.log('Propriedade lock', props.propriedade)
        setLockPropriedade(plantios.length !== 0 || props.propriedade !== undefined)
    }, [plantios])

    async function cadastrar(event: React.FormEvent) {
        event.preventDefault();
        // var plano: any
        // if(props.plano === null){
        //     plano = newPlano()
        //     plano.safra.id = 1
        //     plano.propriedade = propriedade
        //     plano.responsavel_tecnico = pessoaRT?.user
        //     plano.drt = drt?.toString() || ''
        //     plano.doc_drt = files[0]
        //     setWaiting(true)
        //     plano = await API.cadastrarPlano(plano)
        //     if (!plano || !plano.id) {
        //         console.error('Falha ao cadastrar o plano.')
        //         toast.current?.show({ severity: 'error', summary: 'Cadastro do Plantio', detail: 'Falha ao cadastrar o plano.' })
        //         setWaiting(false)
        //         return
        //     }
        //     console.log('Plano cadastrado:', plano)
        // } else {
        //     plano = props.plano
        //     console.log('Usando plano existente:', plano)
        // }
        // let erro: boolean = false
        // let errorMsg: string = ''
        // const promises = plantios.map(async (p: PlantioType) => {
        //     if (erro) { return }
        //     console.log('Cadastrando Plantio:', p)
        //     p.plano = plano
        //     const plantio: PlantioType = await API.cadastrarPlantio(p)
        //     console.log('Plantio response:', plantio)
        //     if (!plantio) {
        //         errorMsg = 'Falha ao cadastrar o plantio';
        //         console.error(errorMsg);
        //         return
        //     }
        //     if (p.lotes)
        //         return await API.cadastrarPlantioLote(plantio, p.lotes)
        // })
        // const a = await Promise.all(promises)
        // console.log('Fim do cadastro', a)
        var plano = newPlano()
        plano.safra = 1
        plano.propriedade = propriedade
        plano.responsavel_tecnico = pessoaRT?.user
        plano.drt = drt?.toString() || ''
        plano.doc_drt = files[0]
        setWaiting(true)
        const req = await API.cadastrarPlanoCompleto(plano, plantios)
        console.log('Req cadastro completo:', req)
        let erro: boolean = req.ok === false
        let errorMsg: string = req.detail
        setWaiting(false)
        if (erro) {
            toast.current?.show({ severity: 'error', summary: 'Cadastro de Plantio', detail: errorMsg })
        } else {
            toast.current?.show({ severity: 'success', summary: 'Cadastro de Plantio', detail: 'Cadastro bem sucedido' })
            resetCadastroPlantio()
        }
    }
    const resetCadastroPlantio = () => {
        console.log('Resetando cadastro de plantio')
        setPlantios([])
        setCampoCpfCnpj('')
        setCpfNome('')
        setDrt(null)
        setPessoaRT(null)
        setFiles([])
        setPlantio(newPlantio())
        console.log('Resetando cadastro de plantio')
    }
    const onFocusCultura = async (e: React.FocusEvent<HTMLInputElement, Element>) => {
        //console.log('culturas', culturas)
        culturas.length === 0 && await carregarCulturas()
    }

    const [errorNome, setErrorNome] = useState('')
    const toast = useRef<Toast | null>(null);


    const headerElement = (
        <div style={{ width: '100%', display: 'flex', alignItems: 'center' }}>
            <PiPlantFill />
            <span style={{ marginLeft: 10, marginRight: 10, width: '100%' }}>Cadastro de Plantio</span>
        </div>
    )

    const footerElement = (
        <div>
            <Button label={waiting ? '' : 'CADASTRAR'} icon={waiting ? '' : 'pi pi-send'} iconPos='right' severity="success" rounded onClick={cadastrar} disabled={plantios.length===0||!pessoaRT||waiting} >{waiting && <ProgressSpinner style={{ width: '20px', height: '20px' }} strokeWidth="8" />}</Button>
        </div>
    )

    const searchCultura = (event: AutoCompleteCompleteEvent) => {
        setTimeout(() => {
            let _filteredCulturas: Array<string> = culturas.map(cultura => cultura.nome.toUpperCase())
            _filteredCulturas = _filteredCulturas.filter(nome => nome.includes(event.query.toUpperCase()))
            setListaCulturas(_filteredCulturas)
        }, 500);
    }
    const searchVariedade = (event: AutoCompleteCompleteEvent) => {
        setTimeout(() => {
            let _filteredVariedades: Array<string> = variedades.map(v => v.cultivar)
            _filteredVariedades = _filteredVariedades.filter(nome => nome.toLowerCase().includes(event.query.toLowerCase()))
            setListaVariedades(_filteredVariedades)
        }, 500)
    }

    return (
        <Dialog visible={props.visible} header={headerElement} footer={footerElement} maximizable style={{ width: '1000px', maxWidth: '100dvw' }} onHide={() => { props.setVisible(false) }} resizable position={'center'} modal>
            <Messages ref={msgs} style={{ position: 'fixed', bottom: 20, right: 280 }} />
            <ConfirmDialog />
            <Toast ref={toast} position="bottom-right" />
            <Divider align="left">
                <div style={{ display: 'flex', alignItems: 'center', width: '100%' }}>
                    <MdMap style={{ marginRight: 5 }} />
                    <b>Lotes</b>
                    {/* {lotes.length > 0 && <Badge value={lotes.length} />} */}
                    {countLotes > 0 && <Badge style={{ marginLeft: 5 }} value={countLotes} />}
                </div>
            </Divider>
            <LotesSelect propriedades={props.propriedades} lotes={lotes} setCount={(value: number) => setCountLotes(value)} setPropriedade={setPropriedade} propriedade={props.propriedade} />
            <div style={{ height: 5 }} />
            {(props.config === CadastroPlantioConfig.CADASTRO_PRODUTOR) &&
                <>
                    <Divider align="left">
                        <div style={{ display: 'flex', alignItems: 'center', width: '100%' }}>
                            <PiPlantFill style={{ marginRight: 5 }} />
                            <b>Plantio</b>
                            {plantios.length !== 0 && <Badge style={{ marginLeft: 5 }} value={plantios.length} />}
                        </div>
                    </Divider>
                    <div className="flex flex-column p-inputgroup flex-1">
                        <span className="p-inputgroup-addon"> <EventIcon /> <b>Data de Plantio</b></span>
                        <Calendar name='data' inputId='data' dateFormat={'dd/mm/yy'}
                            // minDate={new Date()}
                            value={plantio.data} onChange={changeFieldGeneric} showIcon />
                    </div>
                    {errorNome.length > 0 && <small style={{ color: 'red', paddingInlineStart: 5 }}>{errorNome}</small>}
                    <div style={{ height: 5 }} />
                    <div className="flex flex-column p-inputgroup flex-1">
                        <span className="p-inputgroup-addon"><GrassIcon /> <b>Cultura</b></span>
                        <span className="p-float-label">
                            <AutoComplete name='cultura' value={plantio.cultura} onChange={changeFieldCultura} suggestions={listaCulturas} dropdown onFocus={onFocusCultura} completeMethod={searchCultura}></AutoComplete>
                            <label htmlFor="cultura">Informe a cultura</label>
                        </span>
                    </div>
                    <div style={{ height: 5 }} />
                    <div className="flex flex-column p-inputgroup flex-1">
                        <span className="p-inputgroup-addon" style={{ width: 290, display: 'flex', justifyContent: 'left' }}><GrassIcon /> <b>Variedade (Cultivar)</b></span>
                        <span className="p-float-label">
                            <AutoComplete name='variedade' value={plantio.variedade} onChange={changeFieldVariedade} suggestions={listaVariededes} dropdown completeMethod={searchVariedade}></AutoComplete>
                            <label htmlFor="variedade">Informe a cultivar</label>
                        </span>
                    </div>
                    <div style={{ height: 5 }} />
                    <div className="flex flex-column p-inputgroup flex-1">
                        <span className="p-inputgroup-addon"><PollIcon /> <b>Produtividade</b></span>
                        <span className="p-float-label">
                            <InputNumber name='produtividade' value={plantio.produtividade} onValueChange={changeFieldGeneric} locale="pt-BR" minFractionDigits={2} maxFractionDigits={2} suffix={' t/ha'} />
                            <label htmlFor='produtividade'>Informe a produtividade em t/ha</label>
                        </span>
                    </div>
                    <div style={{ height: 5 }} />
                    <div style={{ display: 'flex', alignItems: 'center' }}>
                        <div className="p-inputgroup">
                            <span className="p-inputgroup-addon"><GiWaterDrop /><b>Sistema de Irrigação</b></span>
                            <ToggleButton name={'irrigacao_fluvial'} onLabel={'Fluvial'} offLabel={'Fluvial'}
                                onIcon={<FaWater style={{ marginRight: 5 }} />} offIcon={<FaWater style={{ marginRight: 5 }} />}
                                checked={plantio.irrigacao_fluvial} onChange={changeFieldGeneric} />
                            <ToggleButton name={'irrigacao_poco'} onLabel={'Poço'} offLabel={'Poço'}
                                onIcon={<FaArrowUpFromWaterPump style={{ marginRight: 5 }} />} offIcon={<FaArrowUpFromWaterPump style={{ marginRight: 5 }} />}
                                checked={plantio.irrigacao_poco} onChange={changeFieldGeneric} />
                        </div>
                    </div>
                    <div style={{ width: '100%', display: 'flex', justifyContent: 'end' }}>
                        <Button icon={<AddCircleIcon />} onClick={addPlantio} disabled={lotes.length === 0||!plantio.cultura||!plantio.variedade||!plantio.data}> <b>Adicionar</b></Button>
                    </div>
                </>
            }
            <div style={{ height: 5 }} />
            <DataTable value={plantios} tableStyle={{ minWidth: '50rem' }} dataKey="id">
                <Column header="Plantio" body={plantioTemplate} ></Column>
                <Column header="Cultura" field='cultura' ></Column>
                <Column header="Cultivar" field='variedade'></Column>
                <Column header="Produtividade" body={produtividadeTemplate}></Column>
                <Column header="Irrigação" body={irrigacaoTemplate}></Column>
                <Column header="Lotes" body={lotesTemplate}></Column>
                <Column body={actionBodyTemplate} exportable={false} style={{ width: '5rem' }}></Column>
            </DataTable>
            <div style={{ height: 5 }} />
            <Divider align="left">
                <div style={{ display: 'flex', alignItems: 'center', width: '100%' }}>
                    <PiIdentificationBadgeFill style={{ marginRight: 5 }} />
                    <b>Responsável Técnico</b>
                </div>
            </Divider>
            <InputCpfCnpj value={campoCpfCnpj} setValue={onCpfCnpjSetValue} labelIcon={<BadgeIcon />}
                label={tipoRT.toUpperCase()} onModeChange={setTipoRT} onComplete={completeFieldCPF}
                labelStyle={{ width: '6rem' }} />
            <div style={{
                border: '1px solid #ced4da',
                display: cpfNome.length ? 'block' : 'none',
                paddingInline: 'inherit'
            }}>{cpfNome}</div>
            <div style={{ height: 5 }} />
            {(props.config !== CadastroPlantioConfig.CADASTRO_PRODUTOR) &&
                <>
                    <div className="p-inputgroup flex-1">
                        <span className="p-inputgroup-addon"><InsertDriveFileIcon /><b>DRT</b></span>
                        <InputNumber id='resp' name='responsavel_tecnico'
                            value={drt}
                            onChange={changeFieldDRT}
                            useGrouping={false}
                            disabled={props.config !== CadastroPlantioConfig.APROVACAO_RT}
                        />
                    </div>
                    <div style={{ height: 5 }} />
                    <DocumentFileUpload
                        label="Documento de Responsabilidade Técnica"
                        icon={<InsertDriveFileIcon />}
                        initialFile={files[0]}
                        onFileSelect={(file) => setFiles(file ? [file] : [])}
                        editMode={props.config !== CadastroPlantioConfig.APROVACAO_RT}
                    />
                </>
            }
        </Dialog >
    );
}